import React from 'react';

import styled from '@emotion/styled';
import { Link } from 'gatsby';

const Container = styled.a(props => ``);

const ContainerLink = Container.withComponent(Link);

export default class Btn extends React.Component {
  render() {
    return (
      <ContainerLink to={this.props.to}>
        <span>{this.props.children}</span>
      </ContainerLink>
    );
  }
}
